// Typelizer digest 278975751ae127743cdf98d8b03c9326
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /admin/users/:id/digest */
  digest: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/users/:id/digest', params, options),
    method: 'get',
  }),

  /** GET /admin/users */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/users', {}, options),
    method: 'get',
  }),

  /** GET /admin/users/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/users/:id', params, options),
    method: 'get',
  }),

  /** DELETE /admin/users/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/admin/users/:id', params, options),
    method: 'delete',
  }),
}
